import http from '../http';

// 关联跨夜审退款列表
const fetchRefundCrossNightList = (params) => {
  return http({
    url: `/transactions/cross-night-refund/list/${params.resvNo}`,
  });
};

// 前台、跨夜审退款详情
const fetchRefundCrossNightItemDetail = (params) => {
  return http({
    url: `/transactions/reception-refund/detail/${params.no}`,
  });
};

// 房间订单退款详情
const fetchRefundItemDetail = (params) => {
  return http({
    url: `/bills/items/refund/detail/${params.refundBillItemNo}`,
  });
};

// 获取退款信息
const fetchRefundInfo = (data) => {
  return http({
    url: '/bills/items/refund/choice',
    method: 'POST',
    data,
  });
};

// 确认退款
const confirmRefund = (data) => {
  return http({
    url: '/bills/items/refund',
    method: 'POST',
    data,
  });
};

// 确认部分退款
const confirmPartRefund = (data) => {
  return http({
    url: '/bills/items/refund/part',
    method: 'POST',
    data,
  });
};

// 跨夜审退款
const confirmCrossRefund = (data) => {
  return http({
    url: '/bills/items/refund/cross-night',
    method: 'POST',
    data,
  });
};

// 部分结账确认退款
const partialSettleRefund = (data) => {
  return http({
    url: '/bills/items/refund/partial/checkout/confirm',
    method: 'POST',
    data,
  });
};

export {
  fetchRefundCrossNightList,
  fetchRefundCrossNightItemDetail,
  fetchRefundItemDetail,
  fetchRefundInfo,
  confirmRefund,
  confirmPartRefund,
  confirmCrossRefund,
  partialSettleRefund,
};
